export async function fetchHandler(url) {
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error('An error occurred while fetching URL : ' + url);
  }

  return res.json();
}
